import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import {
  StorageUtil,
  map,
  Store,
  AppState,
  Observable,
  AppFields,
  switchMap,
} from "../store";
import * as lodash from "lodash";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FileUploaderService } from "./file-uploader.service";

@Injectable()
export class VideoService {


  private url = "/api/video";
  private clubUrl = "/api/club";
  private playerUrl = "/api/player";
  private teamUrl = "/api/team";

  team$: Observable<any>;

  constructor(
    private httpService: HttpService,
    private fileUploader: FileUploaderService,
    private _httpClient: HttpClient,
    private store: Store<AppState>
  ) {
    this.team$ = this.store.select(AppFields.App, AppFields.MyTeam);
  }



  // Videos Page
  getVideos(clubID: number) {
    return this.httpService.get(`${this.url}/club-videos/${clubID}/${StorageUtil.userID}`);
  }

  getClubTeamVideos(clubID: number, teamID: number) {
    var userID: number = 0;
    if (teamID > 0) {
      userID = +StorageUtil.userID;
    }
    return this.httpService.get(`${this.url}/club-team-videos/${clubID}/${teamID}/${userID}`);
  }

  getClubVideoUsers(clubVideoID: number) {
    return this.httpService.get(`${this.url}/club-video-users/${clubVideoID}/${+StorageUtil.clubID}/${+StorageUtil.teamId}`);
    //return this.httpService
    //  .get(`${this.url}/club-video-users/${clubVideoID}`)
    //  .pipe(
    //    map((res: any) =>
    //      lodash.sortBy(
    //        res.map((x) => ({
    //          ...x,
    //          watched: x.viewCount > 0 ? 1 : 0,
    //          name: !x.lastName ? x.firstName : `${x.lastName}, ${x.firstName}`,
    //        })),
    //        "name"
    //      )
    //    )
    //  );
  }

  removeVideoFromDatabase(newVideoID: any) {
    return this.httpService.post(this.url + '/remove-new-club-video-from-database/' + newVideoID);
  }

  createNewClubVideoPlaceholder(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this.url + '/create-new-club-video-placeholder', payload, httpOptions);
  }

  CreateClubTeamGameVideoResponseNew(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this.url + '/create-club-team-video-placeholder', payload, httpOptions);
  }

  createClubVideoAndCollegeGameVideoResponse(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this.url + '/create-club-video-and-college-placeholder', payload, httpOptions);
  }

  uploadLargeFileToAWS(
    formData: FormData,
    _headers: {
      FileName: any;
      ClubVideoTypeID: any;
      Description: any;
      ClubID: string;
      TeamID: string;
      AddedBy: string;
      MatchID: string;
    },
    newVideoID
  ) {
    return this.httpService.postRaw(`${this.url}/upload-video/large/${newVideoID}`, formData, {
      headers: _headers,
    });
  }

  uploadTeamVideoFileOnRequest(
    formData: FormData,
    _headers: {
      ClubID: string;
      // Description: any;
      ClubVideoTypeID: any;
      AddedBy: any;
      TeamID: string;
      MatchID: string;
      CollegeGameVideoRequestID: string;
      CollegeName: any;
      CollegeLogo: any;
      HomeTeamName: any;
      HomeTeamLogo: any;
      AwayTeamName: any;
      AwayTeamLogo: any;
      EventName: any;
      GameDate: any;
      Division: any;
      Flight: any;
      Complex: any;
      Venue: any;
    },
    newVideoID1, newVideoID2
  ) {
    return this.httpService.postRaw(`${this.url}/upload-team-video-file-on-request/large/${newVideoID1}/${newVideoID2}`, formData, {
      headers: _headers,
    });
  }

  uploadVideoNew(
    formData: FormData,
    _headers: {
      ClubID: string;
      ClubVideoTypeID: any;
      AddedBy: any;
      TeamID: string;
      MatchID: string;
      FileName: string;
      RelatedClubVideoID: number;
    },
    newVideoID: number, newVideoID1: number
  ) {
    return this.httpService.postRaw(`${this.url}/upload-video-new/large/${newVideoID}/${newVideoID1}`, formData, {
      headers: _headers,
    });
  }

  shareVideo(data) {
    return this.httpService.post(
      `${this.url}/club-share-video/${+StorageUtil.clubID}/${+StorageUtil.teamId}`,
      data
    );
  }

  unshareVideo(ids: number[]) {
    return this.httpService.post(`${this.url}/club-unshare-video`, ids);
  }

  unshareClubVideoByUserIDandClubVideoID(userID: number, clubVideoID: number, updatedBy: number) {
    return this.httpService.post(`${this.url}/unshare-clubvideo-by-userID-and-clubvideoID/${userID}/${clubVideoID}/${updatedBy}`);
  }

  deleteVideo(ids: number[]) {
    return this.httpService.post(`${this.url}/club-delete-video`, ids);
  }

  updateNote(payload: any) {
    return this.httpService.post(
      `${this.url}/club-video-note`,
      payload
    );
  }

  uploadVideo(file, name) {
    return this.httpService.upload(
      `/api/player/UploadVideoFile/${StorageUtil.userID}`,
      file,
      name
    );
  }

  uploadMultipleVideos(file, data) {
    console.log("Files in Service ==> ", file);
    return this.httpService.post(
      `${this.url}/upload-video/${StorageUtil.clubID}`,
      file,
      { params: { uploadedBy: StorageUtil.userID } }
    );
    // return this.fileUploader.upload(file[0], data);
  }

  // Game Exchange Page
  getClubEventListForGameEx(clubID: number) {
    return this.httpService.get(
      `${this.clubUrl}/get-club-event-list-for-game-ex/${clubID}`
    );
  }

  getClubEventListForGameExchange(clubID: number) {
    return this.httpService.get(
      `${this.clubUrl}/get-club-event-list-for-game-exchange/${clubID}`
    );
  }

  getEventsByYearAndStateAndEventType(
    year: number,
    stateID: number,
    eventType: number,
    teamID: number
  ) {
    return this.httpService.get(
      `${this.clubUrl}/get-events-by-year-and-state-and-event-type/${year}/${stateID}/${eventType}/${teamID}`
    );
  }

  getClubEventListByID(clubID: any) {
    return this.httpService.get(
      `${this.clubUrl}/get-club-event-list-by-id/${clubID}`
    );
  }

  getClubEventTeamsByDivision(event: any, divisionID: any) {
    return this.httpService.get(
      `${this.clubUrl}/get-club-event-teams-by-division/${event}/${divisionID}`
    );
  }

  getClubEventsByYearAndStateAndEventType(
    year: number,
    stateID: number,
    eventType: number
  ) {
    return this.httpService.get(
      `${this.clubUrl}/get-club-events-by-year-and-state-and-event-type/${year}/${stateID}/${eventType}`
    );
  }

  getClubTeamsByEventIDDivisionIDGenderClubID(eventID: number, divisionID: number, gender: string, clubID: number) {
    return this.httpService.get(`${this.clubUrl}/get-club-event-teams-by-eventid-divisionid-gender-clubid/${eventID}/${divisionID}/${gender}/${clubID}`)
  }

  getEventDivisionsByEventAndGender(eventID: any, gender: any) {
    return this.httpService.get(
      `${this.clubUrl}/get-event-divisions-by-event-and-gender/${eventID}/${gender}`
    );
  }

  getEventDivisionsByEventIDGenderClubID(eventID: any, gender: any, clubID) {
    return this.httpService.get(
      `${this.clubUrl}/get-event-divisions-by-eventid-gender-clubid/${eventID}/${gender}/${clubID}`
    );
  }



  getEventGamesByEventIDAndTeamID(eventID: number, teamID: number) {
    return this.httpService.get(
      `${this.clubUrl}/get-event-games-by-event-id-and-team-id/${eventID}/${teamID}`
    );
  }

  getTeamEventAndTeamDivisionListByTeamID(teamID: number) {
    return this.httpService.get(
      `${this.teamUrl}/get-team-event-and-team-division-list-by-teamID/${teamID}`
    );
  }

  getDivisionsByEventID(eventID: number) {
    return this.httpService.get(
      `${this.playerUrl}/get-division-by-eventID/${eventID}`
    );
  }

  getFlightsByDivisionID(divisionID: number) {
    return this.httpService.get(
      `${this.playerUrl}/get-flights-by-divisionID/${divisionID}`
    );
  }


  getTeamsByEventIDAndDivisionID(eventID: number, divisionID: number) {
    return this.httpService.get(
      `${this.clubUrl}/get-event-team-list-for-game-ex/${eventID}/${divisionID}`
    );
  }

  getClubGameExchangeDataSearchList(searchObj: any) {
    return this._httpClient.post(
      `${this.clubUrl}/get-club-game-exchange-data-search-list`,
      searchObj
    );
  }

  addGameVideo(obj: any) {
    return this._httpClient.post(
      `${this.clubUrl}/create-club-league-exchange`,
      obj
    );
  }

  SendGameExchangeDownloadVideoLink(obj: any) {
    return this._httpClient.post(
      `${this.clubUrl}/send-game-exchange-download-video-link`,
      obj
    );
  }

  getVideoCenterDashboardDate(clubID: number) {
    return this.team$.pipe(
      switchMap((team) =>
        this.httpService.get(
          `${this.clubUrl}/get-video-center-dashboard-data/${clubID}`,
          { params: { teamID: team ? team.teamID : 0 } }
        )
      )
    );
  }

  getTGSVideos() {
    return this.httpService.get(`${this.url}/get-TGS-videos/`);
  }

  createUserClubVideo(obj: any) {
    return this._httpClient.post(`${this.clubUrl}/create-user-club-video`, obj);
  }

  deleteTgsVideosByUser(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this.url + '/delete-tgs-videos-by-user', payload, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/video.service.ts